import styles from "../../../styles/Components/alert-system/alert-strategy/CreateNewStrategyBox.module.css";
import { FaCirclePlus } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

function CreateNewStrategyBox() {
  const navigate = useNavigate();

  return (
    <div
      className={styles.container}
      onClick={(e) => {
        e.stopPropagation();
        navigate("/insight");
      }}
    >
      <FaCirclePlus size={30} color="#2a86ff" />
      <h4>Create New Strategy</h4>
      <p>Build a custom alert strategy using our Strategy Builder</p>
    </div>
  );
}

export default CreateNewStrategyBox;
